<!-- Page banner Area -->
<div class="page-banner bg-1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>Profile</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Profile</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<div class="sign-in-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <div class="text-center mb-4">
                    <h2 class="fw-bold mb-2">Update Your Account!</h2>
                    <p class="text-muted mb-0">Manage your account information and password from one place.</p>
                </div>

                <div class="card auth-card rounded-4">
                    <div class="card-body p-4 p-md-5 rounded-4">
                        <form [formGroup]="userProfileFormGroup">

                            <!-- <div class="flex flex-col w-full lg:w-1/2 md:w-1/2 sm:w-1/2 lg:pr-2 md:pr-2 sm:pr-2">
                    <div class="relative w-24 h-24">
                        <ng-container *ngIf="selectedImage; else noImage">
                            <img class="w-full h-full rounded-full" style=" border-radius: 50%;"
                                [src]="imagePath + selectedImage" alt="User profile photo" />
                        </ng-container>
                        <ng-template #noImage>
                            <iconify-icon icon="bx:user-circle" height="100%" width="100%"></iconify-icon>
                        </ng-template>
                    </div>

                    <div class=" mt-10 mb-5">
                        <button type="button" class="btn default-btn-one" (click)="selectFile.click()">
                            <i class='bx bx-upload'></i>
                            {{'profile.upload_image' | translate }}
                        </button>
                        <input class="upload" name="image" type="file" hidden #selectFile
                            (change)="onFileUpload($event)" /><br />
                    </div>
                </div> -->
                            <div class="row g-3">
                                <div class="col-md-6">
                                    <label for="first_name" class="form-label fw-semibold small mb-2">First name</label>
                                    <input type="text" class="form-control border" id="first_name"
                                        placeholder="First name" formControlName="first_name" name="first_name">
                                    <div class="text-danger small mt-2" *ngIf="
                                    userProfileFormGroup.controls['first_name'].invalid &&
                                    (userProfileFormGroup.controls['first_name'].dirty ||
                                        userProfileFormGroup.controls['first_name'] .touched || isSubmit)
                                ">
                                        <span *ngIf="
                                        userProfileFormGroup.controls['first_name'].errors
                                            .required
                                    ">
                                            Please enter your first name!
                                        </span>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label for="last_name" class="form-label fw-semibold small mb-2">Last name</label>
                                    <input type="text" class="form-control border" id="last_name"
                                        placeholder="Last name" formControlName="last_name" name="last_name">
                                    <div class="text-danger small mt-2" *ngIf="
                                    userProfileFormGroup.controls['last_name'].invalid &&
                                    (userProfileFormGroup.controls['last_name'].dirty ||
                                        userProfileFormGroup.controls['last_name'] .touched || isSubmit)
                                ">
                                        <span *ngIf="
                                        userProfileFormGroup.controls['last_name'].errors
                                            .required
                                    ">
                                            Please enter your last name!
                                        </span>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label for="email" class="form-label fw-semibold small mb-2">Email</label>
                                    <input type="email" class="form-control border" id="email" placeholder="Email"
                                        formControlName="email" name="email">
                                    <div class="text-danger small mt-2" *ngIf="
                                    userProfileFormGroup.controls['email'].invalid &&
                                    (userProfileFormGroup.controls['email'].dirty ||
                                        userProfileFormGroup.controls['email'] .touched || isSubmit)
                                ">
                                        <span *ngIf="
                                        userProfileFormGroup.controls['email'].errors
                                            .required
                                    ">
                                            Please enter your email!
                                        </span>
                                        <span *ngIf="
                                        userProfileFormGroup.controls['email'].errors
                                            .email
                                    ">
                                            Please enter your email address!
                                        </span>
                                        <span *ngIf="userProfileFormGroup.controls['email'].errors.email">
                                            Please enter your email address!
                                        </span>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label for="phone_no" class="form-label fw-semibold small mb-2">Phone Number</label>
                                    <input type="number" (wheel)="stopScrollingWheel($event)"
                                        class="form-control border" id="phone_no" placeholder="Phone Number"
                                        formControlName="phone_no" name="phone_no">
                                    <div class="text-danger small mt-2" *ngIf="
                                    userProfileFormGroup.controls['phone_no'].invalid &&
                                    (userProfileFormGroup.controls['phone_no'].dirty ||
                                        userProfileFormGroup.controls['phone_no'] .touched || isSubmit)
                                ">
                                        <span *ngIf="
                                        userProfileFormGroup.controls['phone_no'].errors
                                            .required
                                    ">
                                            Phone number is Required!
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 mt-4">
                                <button type="button" class="btn auth-btn" (click)="updateProfile()"
                                    [disabled]="isDisableFlow">Update</button>
                                <a class="fw-semibold text-decoration-none" style="cursor: pointer;"
                                    (click)="isChangePassword = !isChangePassword">
                                    <span>
                                        {{ isChangePassword ? "Don't want" : "Want" }} to change password?</span>
                                </a>
                            </div>
                        </form>

                        <div *ngIf="isChangePassword" class="profile-password-box rounded-4 mt-4 pt-4 px-3 pb-3">
                            <div class="text-center mb-4">
                                <h5 class="fw-bold mb-1">Change Password</h5>
                                <p class="text-muted mb-0 small">Update your password securely.</p>
                            </div>

                            <form [formGroup]="changePasswordFormGroup">
                                <div class="mb-3">
                                    <label for="old_password" class="form-label fw-semibold small mb-2">Current
                                        Password</label>
                                    <input type="password" class="form-control border" id="old_password"
                                        placeholder="Current Password" formControlName="old_password"
                                        name="old_password" required autocomplete="new-password">
                                    <div class="text-danger small mt-2" *ngIf="
                                    changePasswordFormGroup.controls['old_password'].invalid &&
                                    (changePasswordFormGroup.controls['old_password'].dirty ||
                                        changePasswordFormGroup.controls['old_password'] .touched || isSubmit)
                                ">
                                        <span *ngIf="
                                        changePasswordFormGroup.controls['old_password'].errors
                                            .required
                                    ">
                                            Current Password is Required!
                                        </span>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="password" class="form-label fw-semibold small mb-2">New Password</label>
                                    <input type="password" class="form-control border" id="password"
                                        placeholder="New Password" formControlName="password" name="password">
                                    <div class="text-danger small mt-2" *ngIf="
                                    changePasswordFormGroup.controls['password'].invalid &&
                                    (changePasswordFormGroup.controls['password'].dirty ||
                                        changePasswordFormGroup.controls['password'] .touched || isSubmit)
                                ">
                                        <span *ngIf=" changePasswordFormGroup.controls['password'].errors.required">
                                            New Password
                                        </span>
                                        <span *ngIf="changePasswordFormGroup.controls['password'].errors?.minlength">
                                            Password must be at least 8 characters long.
                                        </span>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="confirmPassword" class="form-label fw-semibold small mb-2">Confirm
                                        Pasword</label>
                                    <input type="password" class="form-control border" id="confirmPassword"
                                        placeholder="Confirm Pasword" formControlName="confirmPassword"
                                        name="confirmPassword">
                                    <div class="text-danger small mt-2" *ngIf="
                                    changePasswordFormGroup.controls['confirmPassword'].invalid &&
                                    (changePasswordFormGroup.controls['confirmPassword'].dirty ||
                                        changePasswordFormGroup.controls['confirmPassword'] .touched || isSubmit)
                                ">
                                        <span *ngIf="
                                        changePasswordFormGroup.controls['confirmPassword'].errors
                                            .required
                                    ">
                                            Confirm Password is Required!
                                        </span>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button type="button" class="btn auth-btn auth-btn--secondary"
                                        (click)="changePassword()">Change</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>